<template>
  <div class="leftres">
    <div>
      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;">
        <CusPageBannerManage :tableData="tabledata" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></CusPageBannerManage>
      </div>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import CusPageBannerManage from './components/CusPageBannerManage.vue'
import { BannerList, } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    CusPageBannerManage
  },
  data() {
    return {
      showorhide: false,
      pageSize: 20,
      pageIndex: 1,
      total: 0,
      formdata: [
      ],
      tabledata: [],

    }
  },
  created() {
  },
  mounted() {
    this.BannerList()
  },
  methods: {
    async BannerList() {
       const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        data,
        message,
      } = await BannerList({
        IsForEdit: 1,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
      if (code == 0) {
        this.total = data.Count
        this.tabledata = data.data
      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    reset() {
      this.$refs.select.map((item, index) => {
        item.modelvalue = ''
      })
      this.dialogVisibles = true
    },
    hide() {
      this.showorhide = false
      //console.log("askdas", this.showorhide)

    },
    showclick() {
      this.showorhide = true
    },
    select() {
      try {
        let e = this.$refs.select
        // this.parentId = e[0].modelvalue
        // this.zname = e[1].modelvalue
        // this.type = e[2].modelvalue
        // this.organizationList()
      } catch (error) {
        this.BannerList()
      }
    },
    handleCurrentChange(PageIndex) {
      this.pageIndex = PageIndex
      this.BannerList()
    },
    handleSizeChange(PageSize) {
      this.pageSize = PageSize
      this.BannerList()
    },
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  animation: shows 0.2s ease-in;
  overflow: hidden;
}
.inputtops {
  width: 980px;
  height: 0;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  overflow: hidden;
  // animation: hides 0.5s ease-in;
}
@keyframes shows {
  0% {
    height: 0px;
  }
  100% {
    height: 40px;
  }
}
@keyframes hides {
  0% {
    height: 40px;
  }
  100% {
    height: 0px;
  }
}
</style>